export default __webpack_public_path__ + "static/media/likert-scale.50411663.svg";